<template>
  <div class="login-container">
    <div class="login-page">
      <!-- MOBILE & TABLET -->
      <div class="mobile-layout">
        <div class="mobile-logo">
          <img src="@/assets/logo-2.png" alt="Logo" />
        </div>
        <div class="form-container">
          <router-view></router-view>
        </div>
      </div>

      <!-- DESKTOP -->
      <div class="desktop-layout">
        <div class="form-side">
          <div class="form-container">
            <router-view></router-view>
          </div>
        </div>
        <div class="image-side">
          <img src="@/assets/logo-2.png" alt="Logo" class="desktop-logo" />
          <div class="image-overlay"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuthLayout',
}
</script>

<style lang="scss" scoped>
.login-page {
  background-color: #fff;
  min-height: 100vh;

  display: flex;
  flex-direction: column;

  .mobile-layout {
    display: flex;
    flex-direction: column;
    gap: 2rem;

    .mobile-logo {
      padding: 1.5rem;
      background-color: #1b2c5a;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 12.5rem;
      }
    }

    .form-container {
      flex: 1;
      width: 100%;
      padding: 2rem;
    }

    @media (min-width: 1024px) {
      display: none;
    }
  }

  .desktop-layout {
    display: none;
    width: 100%;

    @media (min-width: 1024px) {
      display: flex;
      height: 100vh;

      .form-side {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;

        .form-container {
          width: 100%;
          margin: 3rem;
          max-width: 27.875rem;
        }
      }

      .image-side {
        flex: 1;
        background-image: url('../../assets/login-banner.jpg');
        background-size: cover;
        background-position: center;
        position: relative;
        border-radius: 0 0 0 221px;

        .desktop-logo {
          padding: 2rem;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 100%;
          max-width: 40.3125rem;
          height: auto;
          z-index: 2;
        }

        .image-overlay {
          position: absolute;
          top: 0;
          left: 0;
          background-color: rgba(28, 45, 90, 0.81);
          width: 100%;
          height: 100%;
          mix-blend-mode: multiply;
          border-radius: 0 0 0 221px;
          z-index: 1;
        }
      }
    }
  }
}
</style>
